import * as PIXI from 'pixi.js';
import { degreesToRadians } from 'maths';
import { state } from '__common/store';
import { getRenderer } from '__editor/panelsEditor/components/renderer/renderer';

// UBuilder-Lite-only background. Renders an invisible placeholder sprite —
// the visible 24px grid is drawn via CSS on the outer div so it stays crisp
// regardless of Pixi zoom. Routed to from backgrounds.ts:whiteBackgroundModel
// when state().app.isUbuilderLite is true; legacy editor keeps the original
// solid-white-with-border background untouched.
export const whiteBackgroundModelLite = (x: number, y: number, rotation: number) => {
  const { background: { bgResized } } = state();
  const bg: PIXI.Graphics = new PIXI.Graphics();
  const width = bgResized ? 1280 * 2 : 1280;
  const height = bgResized ? 1280 * 2 : 1280;
  bg.beginFill(0xFFFFFF, 0);
  bg.drawRect(0, 0, 1280, 1280);
  bg.endFill();
  const renderer = getRenderer();
  const texture = renderer
    ? renderer.generateTexture(bg)
    : PIXI.Texture.WHITE;
  const bgSprite = new PIXI.Sprite(texture);
  bgSprite.id = 'background';
  bgSprite.anchor.set(0.5, 0.5);
  bgSprite.rotation = degreesToRadians(rotation);
  bgSprite.zIndex = -1;
  bgSprite.x = x;
  bgSprite.y = y;
  bgSprite.width = width;
  bgSprite.height = height;
  return bgSprite;
};
